import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initUserManager, getUserManager } from './auth/oidcUserManager';

const root = ReactDOM.createRoot(document.getElementById('root'));

async function bootstrap() {
    try {
        const resp = await fetch('/api/settings');
        const settings = await resp.json();
        initUserManager(settings.oidcAuthority, settings.oidcClientId);

        // Handle OIDC redirect callback (code= in URL query)
        const userManager = getUserManager();
        if (window.location.search.includes('code=') || window.location.search.includes('error=')) {
            try {
                await userManager.signinRedirectCallback();
                window.history.replaceState({}, document.title, window.location.pathname);
            } catch (e) {
                console.error('OIDC callback error', e);
            }
        }
    } catch (e) {
        console.error('Failed to initialize OIDC', e);
    }

    root.render(<App />);
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
